<app-card-consulta (update)="update.emit($event)" [titulo]="titulo" [idConsulta]='idConsulta'
  [tipoConsulta]="tipoConsulta" [codigoControle]="codigoControle"
  [status]="status"
  [msg]="statusMsg"
  [token]="token">

  <ng-container *ngIf="consulta">

    <ul class="card-list card-list-striped">
      <li><span class="text-secondary">Renavam </span><span>{{consulta?.renavam || "NÃO INFORMADO"}}</span></li>
      <li><span class="text-secondary">Chassi </span><span>{{consulta?.chassi || "NÃO INFORMADO"}}</span></li>
      <li><span class="text-secondary">Placa </span><span>{{consulta?.placa || "NÃO INFORMADO"}}</span></li>
      <li><span class="text-secondary">Documento </span><span>{{consulta?.cnpjCpf || "NÃO INFORMADO"}}</span></li>
    </ul>

  </ng-container>

</app-card-consulta>
